(ns app.front.ui.money-input
  (:require [app.front.util :as futil]
            [clojure.string :as str]
            [core.util.string :as str-util]
            [potpuri.core :as p]
            [reagent.core :as r]))


(defn money-input
  "A text field that can handle money (meaning a number with 0-2 digits after the decimal point).
  When the user changes the input value, a callback is called with the value in cents.

  Props:
  `input-params` map, like what you'd give to app.front.ui/text-input with the exception of event
                 handlers, which are handled by the internals of money-input
  `change-fn`    fn, called with the updated value in cents (0 if the input is empty)"
  [{:keys [default-value] :as input-params} _]
  (let [;; Allows ending in . while still writing
        match-input?    (fn [val]
                          (re-matches #"^[0-9]+([,\\.][0-9]{0,2})?$" val))
        ;; Requires exactly 1 or 2 number after a . if present
        match-dispatch? (fn [val]
                          (re-matches #"^[0-9]+([,\\.][0-9]{1,2})?$" val))
        *value          (r/atom (when default-value
                                  (/ default-value 100)))
        *id             (r/atom (:id input-params))]
    (fn [input-params change-fn]
      (let [{:keys [id invalid disabled hide-label required default-value invalid-text]} input-params]
        ;; When ID changes, re-read value from :default-value
        (when (not= @*id id)
          (reset! *id id)
          (reset! *value (when default-value
                           (/ default-value 100))))
        [:div.bx--form-item
         [:label.bx--label
          {:for   id
           :class (futil/cs (when hide-label "bx--visually-hidden")
                            (when disabled "bx--label--disabled")
                            (when required "required-field"))}
          (:label-text input-params)]
         [:input.bx--text-input
          (merge {:type       "text"
                  :value      @*value
                  :max-length 10
                  :on-input   (fn [e]
                                (let [value (futil/tval e)]
                                  (when (or (str/blank? value)
                                            (match-input? value))
                                    (reset! *value (str-util/blank->nil value)))))
                  :on-change  (fn [e]
                                (let [value (futil/tval e)]
                                  ;; Don't call the CB if value is invalid
                                  (if (str/blank? value)
                                    (change-fn nil) ;; User emptied the input
                                    (when (match-dispatch? value)
                                      (change-fn (-> value
                                                     (str/replace #"," ".")
                                                     (futil/parse-number 0.1)
                                                     (* 100)
                                                     Math/round))))))}
                 (p/assoc-if (select-keys input-params [:disabled :placeholder :type :pattern :auto-focus :key :auto-complete :required])
                             :data-invalid (when invalid "true")
                             :aria-invalid (when invalid "true")
                             :aria-describedby (when (and invalid (not (str/blank? invalid-text)))
                                                 (str id "-error-msg"))))]
         (when (and invalid (not (str/blank? invalid-text)))
           [:div.bx--form-requirement {:id (str id "-error-msg")}
            invalid-text])]))))
